import script from "./FindDesignView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FindDesignView.vue?vue&type=script&setup=true&lang=ts"

import "./FindDesignView.vue?vue&type=style&index=0&id=5033dace&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5033dace"]])

export default __exports__